var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-right"},[_c('ihlp-page',{attrs:{"current":_vm.pageVO.curPage,"page-size":_vm.pageVO.pageSize,"total":_vm.pageVO.totalRows,"show-elevator":"","show-sizer":"","show-total":""},on:{"on-change":_vm.onChange,"on-page-size-change":_vm.onPageChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094cbdba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pageVO.vue
// module id = null
// module chunks = 